Namespace 'Customer.Dashboard'

class Customer.Dashboard.SuggestionsBoxView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/body/suggestions_box']
  optionTemplate: JST['backbone/templates/customer/ticket/body/suggestion_option']
  noMatchesTemplate: JST['backbone/templates/customer/ticket/body/suggestions_empty']

  events:
    'submit .suggestions-search': '_fetchSuggestions'
    'click .suggestion-option': '_returnSelectedOption'

  initialize: ->
    @suggestions = new Customer.Dashboard.UserContactCollection()
    @listenTo(@suggestions, 'fetched:suggestions', @_renderSuggestions)

  render: ->
    @$el.html @template()
    @$('#suggestions-modal').modal()
    @

  _fetchSuggestions: (event) ->
    event.preventDefault()
    @_suggestionsList()
      .html('')
      .addClass('processing')
    @suggestions.fetchSuggestions
      searchQuery: @$('.suggestions-search').find('input').val()

  _renderSuggestions: =>
    @_suggestionsList().removeClass 'processing'
    if @suggestions.length
      @_appendSuggestion(suggestion) for suggestion in @suggestions.models
    else
      @_renderNoMatchesMessage()

  _appendSuggestion: (suggestion) ->
    @_suggestionsList().append @optionTemplate
      name: suggestion.get 'name'
      email: suggestion.get 'email'
      score: suggestion.get 'score'

  _renderNoMatchesMessage: ->
    @_suggestionsList().html @noMatchesTemplate()

  _returnSelectedOption: (event) ->
    @trigger 'select:option', $(event.currentTarget).data('value')
    @$('#suggestions-modal').modal 'hide'

  _suggestionsList: ->
    @suggestionsList ||= @$('#suggestions-list')
